import React, { useState, useEffect } from "react";
import { Container, Row, Col, ListGroup, ListGroupItem } from "shards-react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../../firebase";
import "./tab.css";
import moment from "moment";
import { roundOff } from "../../../utils/common_handlers";

const CalibtrationOverView = ({ id }) => {
  // const { id } = useParams();
  const [calibrationData, setCalibrationData] = useState(null);
  const [recordedDeviceData, setRecordedDeviceData] = useState(null);
  useEffect(() => {
    getCalibrationData();
  }, []);

  const getCalibrationData = async () => {
    const docRef = doc(db, "CalibrateResult", id);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      setCalibrationData(docSnap.data());
      if (docSnap.data().RecordedDevice) {
        const deviceData = await getDoc(docSnap.data().RecordedDevice);
        if (deviceData.exists()) {
          setRecordedDeviceData(deviceData.data());
        }
      }
    } else {
      console.log("No such document!");
    }
  };

  const phoneResolution = data => {
    return `${data.width * data.pixelDensity} x ${data.height *
      data.pixelDensity}`;
  };

  return (
    <>
      {calibrationData ? (
        <Container fluid className="main-content-container px-0">
          <Row>
            <Col lg="12" md="12" sm="12" className="mb-4">
              <ListGroup flush>
                <ListGroupItem className="p-0 py-2 border-0">
                  <strong className="text-muted d-block mb-2">
                    Calibrated On Date :{" "}
                    {calibrationData.CalibratedOnDate &&
                      moment(
                        calibrationData.CalibratedOnDate.toDate().toString()
                      ).format("lll")}
                  </strong>
                </ListGroupItem>
                <ListGroupItem className="p-0 py-2 border-0">
                  <strong className="text-muted d-block mb-2">
                    Calibration Avg : {roundOff(calibrationData.CalibrationAvg)}
                  </strong>
                </ListGroupItem>
                <ListGroupItem className="p-0 py-2 border-0">
                  <strong className="text-muted d-block mb-2">
                    Offset Value :{" "}
                    {recordedDeviceData && recordedDeviceData.deviceOffset
                      ? recordedDeviceData.deviceOffset
                      : "-"}
                  </strong>
                </ListGroupItem>
                <ListGroupItem className="p-0 py-2 border-0">
                  <strong className="text-muted d-block mb-2">
                    Pendlum Length : {calibrationData.PendlumLength}
                  </strong>
                </ListGroupItem>
                <ListGroupItem className="p-0 py-2 border-0">
                  <strong className="text-muted d-block mb-2">
                    Phone Resolutions :{" "}
                    {recordedDeviceData && recordedDeviceData.dimensions
                      ? phoneResolution(recordedDeviceData.dimensions)
                      : "-"}
                  </strong>
                </ListGroupItem>
                <ListGroupItem className="p-0 py-2 border-0">
                  <strong className="text-muted d-block mb-2">
                    Device Model :{" "}
                    {recordedDeviceData && recordedDeviceData.model
                      ? recordedDeviceData.model
                      : "-"}
                  </strong>
                </ListGroupItem>
              </ListGroup>
            </Col>
          </Row>
        </Container>
      ) : (
        <Container fluid className="main-content-container px-4">
          <div className="wrapper">
            <div className="spinner">
              <div className="spinner-1"></div>
              <div className="spinner-2"></div>
              <div className="spinner-3"></div>
            </div>
          </div>
        </Container>
      )}
    </>
  );
};

export default CalibtrationOverView;
